export default __webpack_public_path__ + "static/genova-2-6f1f95f9072cc7d6d562b27e444e7a25.jpg";